import React, { useEffect, useState } from "react";
import {
  Backdrop,
  Button,
  Fade,
  FormControl,
  Icon,
  Input,
  InputLabel,
  makeStyles,
  Modal,
} from "@material-ui/core";
import db from "./firebase";
import firebase from "firebase";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormLabel from "@material-ui/core/FormLabel";
import BorderColorIcon from "@material-ui/icons/BorderColor";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    margin: 30,
  },
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: 400,
  },
  form_control: {
    padding: 10,
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    border: "2px solid pink",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    margin: theme.spacing(30),
  },
}));
function Add() {
  const [input, setInput] = useState("");
  const [ini, setIni] = useState("");
  const [priority, setPriority] = useState("green");
  const classes = useStyles();
  const [open, setOpen] = useState(false);

  const handleChange = (event) => {
    setPriority(event.target.value);
  };

  const addTodo = (event) => {
    event.preventDefault(); //This stops the refresh
      if (input == " " || ini == " ") {
          alert("You haven't filled out all the fields!")
      } else {
      db.collection("todos").add({
      todo: input,
      name: ini,
      priority: priority,
      timestamp: firebase.firestore.FieldValue.serverTimestamp(),
    });
}
    setInput(""); //clears the input after saving
    setIni("");
    setPriority("green");
    setOpen(false);
  };
  return (
    <div>
      <Button
        variant="contained"
        color="primary"
        onClick={(e) => setOpen(true)}
        className={classes.button}
        endIcon={
          <Icon>
            <BorderColorIcon />
          </Icon>
        }
      >
        Create a new Todo!
      </Button>

      <Modal
        className={classes.modal}
        open={open}
        onClose={(e) => setOpen(false)}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={open}>
          <div className={classes.paper}>
            <h2 id="transition-modal-title">New Todo</h2>

            <form action="">
              <FormControl className={classes.form_control}>
                <InputLabel>✅ Write a Todo</InputLabel>
                <Input
                  value={input}
                  onChange={(event) => setInput(event.target.value)}
                />
              </FormControl>

              <FormControl className={classes.form_control}>
                <InputLabel>Input your name</InputLabel>
                <Input
                  value={ini}
                  onChange={(event) => setIni(event.target.value)}
                />
              </FormControl>

              <FormControl className={classes.form_control}></FormControl>
              <FormControl
                className={classes.form_control}
                component="fieldset"
              >
                <FormLabel component="legend">Priority Level</FormLabel>
                <RadioGroup row value={priority} onChange={handleChange}>
                  <FormControlLabel
                    value="green"
                    control={<Radio />}
                    label="No"
                  />
                  <FormControlLabel
                    value="yellow"
                    control={<Radio />}
                    label="Low"
                  />
                  <FormControlLabel
                    value="blue"
                    control={<Radio />}
                    label="Medium"
                  />
                  <FormControlLabel
                    value="pink"
                    className={classes.red}
                    control={<Radio />}
                    label="High"
                  />
                  <FormControlLabel
                    color="red"
                    value="red"
                    control={<Radio />}
                    label="Urgent!!!"
                  />
                </RadioGroup>

                <Button
                  disabled={!input}
                  disabled={!ini}
                  type="submit"
                  onClick={addTodo}
                  variant="contained"
                  color="secondary"
                >
                  Add Todo
                </Button>
              </FormControl>
            </form>
            <Button color="primary" onClick={(e) => setOpen(false)}>
              Cancel
            </Button>
          </div>
        </Fade>
      </Modal>
    </div>
  );
}

export default Add;
